import script from "./profile.vue?vue&type=script&setup=true&lang=js"
export * from "./profile.vue?vue&type=script&setup=true&lang=js"

import "./profile.vue?vue&type=style&index=0&id=115a3302&lang=scss"

const __exports__ = script;

export default __exports__